<div id="dynamicForm-form-div" class="phoneDiv">
  <span class="symbolIcon" style="font-size: 1.3rem">+</span>
  <mat-form-field id="inputCOMP-form" [formGroup]="group" class="custom-form-field phoneCodeDiv">
    <mat-label>{{ countryCode.displayName }}</mat-label>
    <input
      matInput
      [formControlName]="countryCode.name"
      [name]="countryCode.name"
      [type]="countryCode.inputType"
      title="Country Code"
      autocomplete="off"
    />
    <ng-container
      id="inputCOMP-form-ng-container"
      *ngFor="let validation of countryCode.validations"
      ngProjectAs="mat-error"
    >
      <mat-error
        id="inputCOMP-form-error{{ countryCode.name }}"
        *ngIf="group.get(countryCode.name).hasError(validation.name)"
        >{{ validation.message }}</mat-error
      >
    </ng-container>
  </mat-form-field>
  <span class="symbolIcon" style="font-size: 2rem">-</span>
  <mat-form-field id="inputCOMP-form" [formGroup]="group" class="custom-form-field phoneNumDiv">
    <mat-label>{{ field.displayName }}</mat-label>
    <input
      matInput
      [formControlName]="field.name"
      [name]="field.name"
      [type]="field.inputType"
      title="Mobile(without country code and area code)"
      autocomplete="off"
    />
    <ng-container id="inputCOMP-form-ng-container" *ngFor="let validation of field.validations" ngProjectAs="mat-error">
      <mat-error id="inputCOMP-form-error{{ field.name }}" *ngIf="group.get(field.name).hasError(validation.name)">
        {{ validation.message }}</mat-error
      >
    </ng-container>
  </mat-form-field>
</div>
